import {z} from 'zod';

export const PhoneNumberSchema = z.object({
  countryCode: z.string(),
  prefix: z.string(),
  number: z.string(),
});
export type PhoneNumber = z.infer<typeof PhoneNumberSchema>;
